export const AR = {
  // Navigation
  startTrial:           'ابدأ التجربة المجانية',
  login:                'تسجيل الدخول',
  smartWriting:         'الكتابة الإرشادية',
  testMode:             'وضع الاختبار',
  ideas:                'الأفكار',
  sentences:            'الجمل',
  vocabulary:           'المفردات',
  middleEast:           'أسئلة الشرق الأوسط',
  getStarted:           'ابدأ الآن',
  viewCourses:          'عرض الدورات',
  bookLesson:           'احجز درساً',
  contactAhmed:         'تواصل مع الأستاذ أحمد',
  hoursRemaining:       'ساعات متبقية',
  nextClass:            'الدرس القادم',
  mySchedule:           'جدولي',
  myEarnings:           'أرباحي',
  welcome:              'أهلاً وسهلاً',
  placementTest:        'اختبار تحديد المستوى',
  upgrade:              'ترقية الاشتراك',
  iHaveAccount:         'لدي حساب — تسجيل الدخول',
  teacherPortal:        'بوابة المعلمين والإدارة',
  noRegNeeded:          'لا يلزم تسجيل',
  backToHome:           'العودة للرئيسية',
  signOut:              'تسجيل الخروج',
  academy:              'الأكاديمية',
  // Errors / status
  invalidEmail:         'بريد إلكتروني غير صحيح',
  invalidPassword:      'كلمة مرور غير صحيحة (8 أحرف على الأقل)',
  loginFailed:          'فشل تسجيل الدخول — تحقق من البريد الإلكتروني وكلمة المرور',
  registrationSuccess:  'تم التسجيل بنجاح — سيتواصل معك الأستاذ أحمد قريباً',
  subscriptionExpired:  'انتهت صلاحية اشتراكك — تواصل مع الأستاذ أحمد للتجديد',
  hoursLow:             'ساعاتك على وشك النفاد — جدد اشتراكك قريباً',
  connectionError:      'خطأ في الاتصال — تحقق من الإنترنت وحاول مجدداً',
  bookingConfirmed:     'تم تأكيد الحجز — ستتلقى رسالة واتساب قريباً',
  passwordMismatch:     'كلمات المرور غير متطابقة',
  fieldRequired:        'هذا الحقل مطلوب',
  sessionExpired:       'انتهت جلستك — سجل الدخول مجدداً',
  forgotPassword:       'نسيت كلمة المرور؟',
  resetPassword:        'إعادة تعيين كلمة المرور',
  newPassword:          'كلمة المرور الجديدة',
  confirmPassword:      'تأكيد كلمة المرور',
  emailAddress:         'البريد الإلكتروني',
  fullName:             'الاسم الكامل',
  whatsapp:             'رقم واتساب',
  register:             'إنشاء حساب',
  termsAgree:           'أوافق على الشروط والأحكام وسياسة الإلغاء',
};

export const EN = {
  // Navigation
  startTrial:           'Start Free Trial',
  login:                'Log In',
  smartWriting:         'Smart Writing',
  testMode:             'Test Mode',
  ideas:                'Ideas',
  sentences:            'Sentences',
  vocabulary:           'Vocabulary',
  middleEast:           'Middle East',
  getStarted:           'Get Started',
  viewCourses:          'View Courses',
  bookLesson:           'Book a Lesson',
  contactAhmed:         'Contact Mr. Ahmed',
  hoursRemaining:       'Hours Remaining',
  nextClass:            'Next Class',
  mySchedule:           'My Schedule',
  myEarnings:           'My Earnings',
  welcome:              'Welcome',
  placementTest:        'Placement Test',
  upgrade:              'Upgrade Access',
  iHaveAccount:         'I Have an Account — Log In',
  teacherPortal:        'Teacher & Admin Portal',
  noRegNeeded:          'No registration needed',
  backToHome:           'Back to Home',
  signOut:              'Sign Out',
  academy:              'Academy',
  // Errors / status
  invalidEmail:         'Invalid email address',
  invalidPassword:      'Password must be at least 8 characters',
  loginFailed:          'Login failed — check your email and password',
  registrationSuccess:  'Registration successful! Mr. Ahmed will activate your account soon.',
  subscriptionExpired:  'Your subscription has expired — contact Mr. Ahmed to renew',
  hoursLow:             'Your hours are running low — renew your subscription soon',
  connectionError:      'Connection error — check your internet and try again',
  bookingConfirmed:     'Booking confirmed — you will receive a WhatsApp message soon',
  passwordMismatch:     'Passwords do not match',
  fieldRequired:        'This field is required',
  sessionExpired:       'Your session has expired — please log in again',
  forgotPassword:       'Forgot your password?',
  resetPassword:        'Reset Password',
  newPassword:          'New Password',
  confirmPassword:      'Confirm Password',
  emailAddress:         'Email Address',
  fullName:             'Full Name',
  whatsapp:             'WhatsApp Number',
  register:             'Create Account',
  termsAgree:           'I agree to the Terms & Conditions and Cancellation Policy',
};

export function useLang(lang = 'en') {
  const dict = lang === 'ar' ? AR : EN;
  return (key) => dict[key] || EN[key] || key;
}

export function loadLang() {
  try { return localStorage.getItem('ic_language') || 'en'; } catch { return 'en'; }
}
export function saveLang(v) {
  try { localStorage.setItem('ic_language', v); } catch {}
}
